import { Image } from '~components/Image';
import { getInitials } from '../utils';

import * as styles from './ComponentReviewsSpotlightItem.module.css';

import type { ContentfulComponentReviewItem } from '../types';

type ComponentReviewsSpotlightItemProps = {
  content: ContentfulComponentReviewItem;
};

export const ComponentReviewsSpotlightItem: React.FC<ComponentReviewsSpotlightItemProps> = ({
  content: { author, content, image, imagePosition, occupation, label },
}) => (
  <div className={styles.slide}>
    {image && <Image className={styles.image} style={{ objectPosition: imagePosition ?? '50% 50%' }} image={image} />}
    <div className={styles.contentWrapper}>
      {label && <span className={styles.label}>{label}</span>}
      <blockquote className={styles.content}>{content.content}</blockquote>
      <div className={styles.author}>
        <div className={styles.initials}>{getInitials(author)}</div>
        <span className={styles.occupation}>{occupation ?? author}</span>
      </div>
    </div>
  </div>
);
